import * as React from 'react';
import {Link} from 'react-router-dom';
import {MenuItemContainer} from '../../../../../system/menu';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Ranges from '../../../../../system/ranges';
import {Alert, Dropdown, DropdownButton} from 'react-bootstrap';
import {DixperStatus} from './DixperStatus';
import {
  DIXPER_CONNECTED,
  DixperInteractor,
} from '../../../../../dixper/DixperInteractor';
import {
  ActionWithProgress,
  HelpWithProgress,
} from '../../../../../system/buttons';
import './dixper.css';
import {DixperRunnerSimple} from '../../../../../dixper/DixperRunnerSimple';
import PulsoidClient from '../../../../../PulsoidClient';
import {HeartRateInteractor} from '../voicemod/HeartrateStatus';
import Toggle from 'react-toggle';
import {Prompt} from 'react-router';
import {DASHBOARD_ROUTES} from '../../../../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../../../../navigation/navigationUtils';
import {HeadTitle} from '../../../../../system/HeadTitle';

export class DixperIntegration extends React.Component {
  state = {
    name: 'kosdfdsf_dsfsdfsdf',
    description: 'Voicemod integration',
    configuration: {
      mode: 'voice_changer',
      ranges: [],
    },
    dixperData: {
      skills: [],
    },
  };

  client = new PulsoidClient();

  interactor = new DixperInteractor(async (status) => {
    if (status === DIXPER_CONNECTED) {
      this.interactor.getSkills().then((skills) => {
        this.setState({dixperData: {skills}});
      });
    }
    this.setState({dixperStatus: status});
  });

  initWebHook = () =>
    this.client
      .getWebHook(this.props.match.params.id)
      .then((res) => this.setState({...res}, () => this.refreshIntegration()));

  componentDidMount() {
    this.initWebHook();
  }

  render() {
    let configuration = this.state.configuration;

    return (
      <MenuItemContainer title={'Integrations'}>
        <Prompt
          when={this.state.dixperStatus === DIXPER_CONNECTED}
          message="Closing this page will stop Dixper integration. Are you sure?"
        />
        <HeadTitle title={this.state.description} />
        <h3>
          <Link to={buildRoute({path: DASHBOARD_ROUTES.INTEGRATIONS})}>
            Integrations
          </Link>
          {` > ${this.state.name}`}
        </h3>
        <div className={'text-muted'}>{this.state.description}</div>
        <hr />
        <Alert variant={'info'}>
          This integration is in BETA now and is free to use. It will be moved
          to the BRO plan on the 1st of September.
        </Alert>
        <Form.Group as={Row}>
          <Col sm={'2'}>Status: {this.state.status}</Col>
          <Col sm="auto" className={'align-vertical-center'}>
            <Toggle
              checked={this.state.status === 'Enabled'}
              onChange={async (e) => {
                await this.client.changeWebHookStatus(
                  this.props.match.params.id,
                  e.target.checked ? 'Enabled' : 'Disabled'
                );
                await this.initWebHook();
                if (this.state.status === 'Enabled') {
                  this.startIntegration();
                } else {
                  this.stopIntegration();
                }
              }}
            />
          </Col>
        </Form.Group>
        <DixperStatus interactor={this.interactor} />

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Heart Rate status
          </Form.Label>
          <Col sm="2" className={'d-flex align-items-center'}>
            {this.state.isHeartRateReceiving ? (
              <div>{this.state.heartRate}</div>
            ) : (
              'No data'
            )}
          </Col>
        </Form.Group>
        <HeartRateInteractor
          url={
            'wss://ramiel2.pulsoid.net/listen/7f20184a-5fcf-11e6-8b77-86f30ca893d3'
          }
          onConnected={(heartRate) =>
            this.setState({heartRate, isHeartRateReceiving: true}, () => {
              if (this.state.status === 'Enabled' && this.state.runner) {
                this.state.runner.onData(heartRate);
              }
            })
          }
          onWaitingData={() =>
            this.setState({heartRate: undefined, isHeartRateReceiving: false})
          }
        />

        <div className={'pt-5'} />
        <Ranges
          ranges={configuration.ranges}
          onRangesChange={(ranges) =>
            this.setState({
              configuration: {
                ...this.state.configuration,
                ranges,
              },
            })
          }
          defaultRange={{
            from: 40,
            to: 90,
            voiceId: '23',
            durationInSeconds: 1234,
          }}
          header={
            <Col md={6}>
              <Form inline>
                <Col>Skill</Col>
              </Form>
            </Col>
          }
          rangeConfiguration={(range, onRangeChange) => {
            let result = this.state.dixperData.skills.find(
              (skill) =>
                range.skill &&
                skill.appearance.name === range.skill.appearance.name
            );

            return (
              <>
                <Col md={'auto'} key={range.from}>
                  <Row className={'pl-3'}>
                    <DropdownButton
                      disabled={!this.interactor.isConnected()}
                      variant="outline-info"
                      title={result ? result.appearance.name : 'Not selected'}
                    >
                      {this.state.dixperData.skills.map((skill) => (
                        <Dropdown.Item
                          onSelect={() =>
                            onRangeChange({
                              ...range,
                              skill,
                            })
                          }
                        >
                          {skill.appearance.name}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </Row>
                </Col>
                <Col md={3}>
                  <HelpWithProgress
                    disabled={!this.interactor.isConnected()}
                    onClick={() => this.interactor.launchSkill(range.skill)}
                  >
                    Trigger
                  </HelpWithProgress>
                </Col>
              </>
            );
          }}
        />
        <Row className={'pt-4'}>
          <Col sm={'auto'}>
            <ActionWithProgress
              onClick={async () => {
                await new PulsoidClient().updateWebHook(
                  this.state.id,
                  null,
                  null,
                  this.state.configuration
                );
                this.refreshIntegration();
              }}
            >
              Update
            </ActionWithProgress>
          </Col>
        </Row>
      </MenuItemContainer>
    );
  }

  refreshIntegration = () => {
    if (this.state.status === 'Enabled') {
      this.startIntegration();
    }
  };

  startIntegration = () => {
    this.setState({
      runner: new DixperRunnerSimple(this.interactor, this.state.configuration),
    });
  };

  stopIntegration = () => {
    this.setState({
      runner: undefined,
    });
  };
}
